export const testimonials = [
  {
    name: 'Matías G.',
    role: 'Personal Trainer',
    initials: 'MG',
    headline: 'A much clearer shoulder progression.',
    quote:
      'As a personal trainer, I wanted a clearer way to organize shoulder rehabilitation exercises. Volume 01 gave me a structured progression with mobility, activation, strengthening and stability work.',
  },
  {
    name: 'Laura M.',
    role: 'Recreational Athlete',
    initials: 'LM',
    headline: 'The knee exercises finally felt organized.',
    quote:
      'After my knee surgery, I needed a clearer way to return to training. Volume 02 gave me exercises by level, with sets, reps and an easy progression to follow.',
  },
  {
    name: 'Federico R.',
    role: 'Physical Education Teacher',
    initials: 'FR',
    headline: 'Ankle work is much easier to structure.',
    quote:
      'Volume 03 helped me organize mobility, strength, balance and proprioception exercises much more clearly.',
  },
]
